module.exports = __webpack_public_path__ + "img/IEC30452.78dba9df.png";